(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$(function () {
  var evt = new Event('tab_anchor_switched');
  $('.tab-anchor').on('click', function () {
    $(this).parent().removeClass('not-active').addClass('active');
    $('.tab-anchor').not($(this)).each(function () {
      $(this).parent().removeClass('active').addClass('not-active');
    });
    var tab = $(this).attr('tab-target');
    $('#' + tab).show();
    $('.tab-pages').not('#' + tab).each(function () {
      $(this).hide();
    });
    this.dispatchEvent(evt);
  });
});

},{}],2:[function(require,module,exports){
"use strict";

require("./components/page-tabs");

},{"./components/page-tabs":1}]},{},[2]);
